import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "items", "empty"]

  filter() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this._applyFilter(), 150)
  }

  _applyFilter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    // Find all tag-toggle controller elements within the items container
    const tags = this.itemsTarget.querySelectorAll("[data-controller='tag-toggle']")
    tags.forEach(tag => {
      const name = (tag.dataset.tagToggleNameValue || "").toLowerCase()
      const match = !query || name.includes(query)
      tag.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    // Also toggle section visibility - hide sections with no visible tags
    const sections = this.itemsTarget.querySelectorAll("[data-controller='collapsible']")
    sections.forEach(section => {
      const visibleTags = section.querySelectorAll("[data-controller='tag-toggle']:not(.hidden)")
      section.classList.toggle("hidden", visibleTags.length === 0)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0 || !query)
    }
  }

  disconnect() {
    clearTimeout(this._timeout)
  }
}
